export default __webpack_public_path__ + "static/media/khanhdao.6f43ffae.png";